
export const USER_ADDRESS_TYPE = 2;
export const USERID_ADDRESS_TYPE = 3;
// ADDRESS_TYPE::EMAIL in dockerized-router (hg/router/dbfuncs.php) — relayed out over
// SMTP by EmailGateway.
export const EMAIL_ADDRESS_TYPE = 5;
export const GROUP_ADDRESS_TYPE = 6;
// ADDRESS_TYPE::CATALINA in dockerized-router (hg/router/dbfuncs.php) — a "#"-prefixed
// transponder address, relayed to the Catalina REST API by CatalinaGateway.
export const CATALINA_ADDRESS_TYPE = 7;
export const ATRAX_ADDRESS_TYPE = 9;
// ADDRESS_TYPE::FEDERATION in dockerized-router (hg/router/dbfuncs.php) — a
// `username@alias` address on another router in the federation.
export const FEDERATION_ADDRESS_TYPE = 11;

export const IMAGE_FILE_TYPE = 11;
export const TEXT_FILE_TYPE = 12;

export const KEYS_USERNAME = "@keys";